export default {
  "DisplayAgreementSummary.Title": "同意事項一覧",
  "DisplayAgreementSummary.Text1":
    "ご自身のデータの取扱いに関する主な同意事項を確認できます",
  "DisplayAgreementSummary.Text2":
    "※ すでに解約されたサービスでの同意事項も表示されております",
  "DisplayAgreementSummary.PrefixText": "詳細は「",
  "DisplayAgreementSummary.FaqLinkText": "よくあるご質問（FAQ）",
  "DisplayAgreementSummary.SuffixText": "」をご確認ください",
}
